const TYPE = 'CHANGE_GROUP_NAME';

const action = (idx, name) => (dispatch) => dispatch({ type: TYPE, payload: { idx, name } });

export default { action, TYPE };
